import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=1d7bbad2"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports